import React, { useState, useEffect } from "react";
import DashboardWrapper from "../shared/DashboardWrapper";
import { Divider, Tabs, Typography } from "antd";
import DiamondIcon from "../../../assets/diamond.svg";
import "./index.css";
import CategoreyRewards from "./CategoreyRewards";
import { useDispatch, useSelector } from "react-redux";
import { setCategory } from "../../../reducers/category";
import { retriveToken, getAllCategory } from "../../../services/AuthServices";

const ClaimReward = () => {
  const dispatch = useDispatch();
  const { category } = useSelector((state) => state.category);
  const auth = useSelector((state) => state.auth);

  const [tabKey, setTabKey] = useState("");

  useEffect(() => {
    const token = retriveToken();
    if (token && token !== "undefined") {
      getAllCategory(token).then((response) => {
        const categories = response?.data?.data;
        dispatch(setCategory(categories));
        if (categories?.length > 0) {
          setTabKey(categories[0]._id);
        }
      });
    } else {
      window.location = "/";
    }
  }, [dispatch]);

  const items = category?.map((item) => ({
    key: item._id,
    label: item.name,
    children: <CategoreyRewards categoryId={item._id} />, // Use item._id here instead of tabKey
  }));

  return (
    <DashboardWrapper isReward={true} title="CLAIM REWARDS">
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div style={{ display: "flex", flexDirection: "column", paddingBottom: "20px", gap: "2px" }}>
          <div style={{ display: "flex", gap: "2px", alignItems: "center" }}>
            <img width="20px" src={DiamondIcon} alt="diamond" />
            <Typography className="rewardPoints">
              {auth?.user?.points?.toLocaleString()}
            </Typography>
          </div>
          <Typography className="pointsText">Points Accumulated</Typography>
        </div>
        <Divider className="divier_edit" />
        <div className="reward_tabs">
          {items?.length > 0 && (
            <Tabs
              items={items}
              activeKey={tabKey}
              onChange={(key) => setTabKey(key)}
              tabBarStyle={{ borderBottom: "none" }}
              style={{borderBottom:"none"}}
            />
          )}
        </div>
      </div>
    </DashboardWrapper>
  );
};

export default ClaimReward;
